module.exports = "https://cdn.realtymogul.com/static/media/social_twitter_gray.0a216a7b.svg";